<template>
  <div id="app-div" style="overflow-y: hidden">
    <a-tabs defaultActiveKey="1" @change="tabChange">
      <a-tab-pane tab="按责编统计" key="1">
        <div class="top">
          <div class="search_icon">
            <span style="margin-left: 10px">
              <img src="../../../assets/u3220.png" class="icon_img" />
              筛选查询
            </span>
          </div>
          <div class="query_div">
            <a-row>
              <a-col :span="5">
                <label>责任编辑：</label>
                <a-input
                  placeholder="请输入"
                  v-model="editorialName"
                  class="query_input"
                />
              </a-col>
              <a-col :span="5">
                <label>年份：</label>
                <a-input
                  placeholder="请输入"
                  v-model="yearLeft"
                  style="width: 100px"
                />
                <label style="padding: 10px">-</label>
                <a-input
                  placeholder="请输入"
                  v-model="yearRight"
                  style="width: 100px"
                />
              </a-col>
              <a-button type="primary" class="query_btn" @click="query"
                >查询</a-button
              >
            </a-row>
          </div>
        </div>

        <div class="middle">
          <div style="float: left; margin-left: 10px">
            <img src="../../../assets/u3227.png" class="icon_img" />
            <span>&nbsp;数据列表</span>
          </div>
        </div>
        <div class="bottom" id="bottom">
          <div class="table_box">
            <a-table
              :pagination="false"
              :rowSelection="rowSelection"
              :columns="editorialcolumns"
              :dataSource="data"
              :rowKey="(record) => record.uId"
              size="small"
              :scroll="{ y: data.length < 7 ? false : table_height }"
              bordered
            ></a-table>
          </div>
          <div id="components-pagination-demo-mini">
            <a-pagination
              :total="total"
              :showTotal="(total) => `共 ${total} 条`"
              showSizeChanger
              showQuickJumper
              :pageSizeOptions="pageSizeOptions"
              :defaultPageSize="limit"
              @showSizeChange="onShowSizeChange"
              @change="pageChange"
            />
          </div>
          <a-select
            defaultValue="0"
            class="batch_operation"
            @change="operateChange"
            v-model="operateCode"
          >
            <a-select-option value="0">批量操作</a-select-option>
            <a-select-option value="1">批量导出</a-select-option>
          </a-select>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="按年份统计" key="2" forceRender>
        <div class="top">
          <div class="search_icon">
            <span style="margin-left: 10px">
              <img src="../../../assets/u3220.png" class="icon_img" />
              筛选查询
            </span>
          </div>
          <div class="query_div">
            <a-row>
              <a-col :span="5">
                <label>年份：</label>
                <a-input
                  placeholder="请输入"
                  v-model="year"
                  style="width: 100px"
                />
              </a-col>
              <a-button type="primary" class="query_btn" @click="query"
                >查询</a-button
              >
            </a-row>
          </div>
        </div>
        <div class="middle">
          <div style="float: left; margin-left: 10px">
            <img src="../../../assets/u3227.png" class="icon_img" />
            <span>&nbsp;数据列表</span>
          </div>
        </div>
        <div class="bottom" id="bottom2">
          <div class="table_box">
            <a-table
              :pagination="false"
              :rowSelection="rowSelection"
              :columns="yearcolumns"
              :dataSource="data"
              :rowKey="(record) => record.uId"
              size="small"
              :scroll="{ y: data.length < 8 ? false : table_height }"
              bordered
            ></a-table>
          </div>
          <div id="components-pagination-demo-mini">
            <a-pagination
              :total="total"
              :showTotal="(total) => `共 ${total} 条`"
              showSizeChanger
              showQuickJumper
              :pageSizeOptions="pageSizeOptions"
              :defaultPageSize="limit"
              @showSizeChange="onShowSizeChange"
              @change="pageChange"
            />
          </div>
          <a-select
            defaultValue="0"
            class="batch_operation"
            @change="operateChange"
            v-model="operateCode"
          >
            <a-select-option value="0">批量操作</a-select-option>
            <a-select-option value="1">批量导出</a-select-option>
          </a-select>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
const editorialcolumns = [
  {
    title: "年份",
    dataIndex: "year",
    align: "center",
    sorter: (a, b) => a.year - b.year,
  },
  {
    title: "稿件数量",
    dataIndex: "strawNum",
    align: "center",
    sorter: (a, b) => a.strawNum - b.strawNum,
  },
  {
    title: "已审回",
    dataIndex: "returnY",
    align: "center",
    sorter: (a, b) => a.returnY - b.returnY,
  },
  {
    title: "未审回",
    dataIndex: "returnN",
    align: "center",
    sorter: (a, b) => a.returnN - b.returnN,
  },
  {
    title: "未送审",
    dataIndex: "awayN",
    align: "center",
    sorter: (a, b) => a.awayN - b.awayN,
  },
  {
    title: "已录用",
    dataIndex: "hireY",
    align: "center",
    sorter: (a, b) => a.hireY - b.hireY,
  },
  {
    title: "已发表",
    dataIndex: "publishY",
    align: "center",
    sorter: (a, b) => a.publishY - b.publishY,
  },
  {
    title: "已退改",
    dataIndex: "alterY",
    align: "center",
    sorter: (a, b) => a.alterY - b.alterY,
  },
  {
    title: "已退稿",
    dataIndex: "backY",
    align: "center",
    sorter: (a, b) => a.backY - b.backY,
  },
];

const yearcolumns = [
  {
    title: "责任编辑",
    dataIndex: "editorial",
    align: "center",
  },
  {
    title: "稿件数量",
    dataIndex: "strawNum",
    align: "center",
    sorter: (a, b) => a.strawNum - b.strawNum,
  },
  {
    title: "已审回",
    dataIndex: "returnY",
    align: "center",
    sorter: (a, b) => a.returnY - b.returnY,
  },
  {
    title: "未审回",
    dataIndex: "returnN",
    align: "center",
    sorter: (a, b) => a.returnN - b.returnN,
  },
  {
    title: "未送审",
    dataIndex: "awayN",
    align: "center",
    sorter: (a, b) => a.awayN - b.awayN,
  },
  {
    title: "已录用",
    dataIndex: "hireY",
    align: "center",
    sorter: (a, b) => a.hireY - b.hireY,
  },
  {
    title: "已发表",
    dataIndex: "publishY",
    align: "center",
    sorter: (a, b) => a.publishY - b.publishY,
  },
  {
    title: "已退改",
    dataIndex: "alterY",
    align: "center",
    sorter: (a, b) => a.alterY - b.alterY,
  },
  {
    title: "已退稿",
    dataIndex: "backY",
    align: "center",
    sorter: (a, b) => a.backY - b.backY,
  },
];

const data = [];
import qs from "qs";

export default {
  data() {
    return {
      data,
      editorialcolumns,
      operateCode: "0",
      editorialName: "",
      yearLeft: "",
      yearRight: "",
      year: "",
      yearcolumns,
      selectedRowKeys: [],
      page: 1,
      limit: 20,
      total: 0,
      groupType: "m.year",
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  name: "workSet",
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  methods: {
    operateChange() {
      if (this.operateCode != "0") {
        var itemLegth = this.selectedRowKeys.length;
        if (itemLegth == 0) {
          this.utils.messageInfo(this, "error", "最少选择一条数据！");
          return;
        }
      }
      if (this.operateCode == "1") {
        if (this.groupType == "m.year") {
          var jsonDataYear = [];
          for (var i = 0; i < this.data.length; i++) {
            for (var j = 0; j < this.selectedRowKeys.length; j++) {
              if (this.data[i].uId == this.selectedRowKeys[j]) {
                var jsonYear = {
                  year: this.data[i].year,
                  strawNum: this.data[i].strawNum,
                  returnY: this.data[i].returnY,
                  returnN: this.data[i].returnN,
                  awayN: this.data[i].awayN,
                  hireY: this.data[i].hireY,
                  publishY: this.data[i].publishY,
                  alterY: this.data[i].alterY,
                  backY: this.data[i].backY,
                };
                jsonDataYear.push(jsonYear);
              }
            }
          }
          exportByYear(jsonDataYear);
        } else if (this.groupType == "mm.user_code") {
          var jsonDataExpert = [];
          for (var n = 0; n < this.data.length; n++) {
            for (var m = 0; m < this.selectedRowKeys.length; m++) {
              if (this.data[n].uId == this.selectedRowKeys[m]) {
                var jsonExpert = {
                  editorial: this.data[n].editorial,
                  strawNum: this.data[n].strawNum,
                  returnY: this.data[n].returnY,
                  returnN: this.data[n].returnN,
                  awayN: this.data[n].awayN,
                  hireY: this.data[n].hireY,
                  publishY: this.data[n].publishY,
                  alterY: this.data[n].alterY,
                  backY: this.data[n].backY,
                };
                jsonDataExpert.push(jsonExpert);
              }
            }
          }
          exportByUser(jsonDataExpert);
        }
      }
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    //左右导航点击后排序
    tabChange(key) {
      this.editorialName = "";
      this.yearLeft = "";
      this.yearRight = "";
      this.year = "";
      this.operateCode = "0";
      if (key == 1) {
        this.groupType = "m.year";
      } else if (key == 2) {
        this.groupType = "mm.user_code";
      }
      this.query();
    },

    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    query() {
      this.axios
        .get("/statistical/workLoad", {
          params: {
            yearLeft: this.yearLeft,
            yearRight: this.yearRight,
            page: this.page,
            limit: this.limit,
            editor: this.editor,
            year: this.year,
            groupType: this.groupType,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 290;
    var bottom = document.getElementById("bottom");
    var bottom2 = document.getElementById("bottom2");
    bottom.style.height = bottom_height + "px";
    bottom2.style.height = bottom_height + "px";
    this.table_height = bottom_height - 160;
  },
};

function exportByYear(jsonData) {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = `年份,稿件数量,已审回,未审回,未送审,已录用,已发表,已退改,已退稿,\n`;
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < jsonData.length; i++) {
    for (let item in jsonData[i]) {
      str += `${jsonData[i][item] + "\t"},`;
    }
    str += "\n";
  }
  //encodeURIComponent解决中文乱码
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
  //通过创建a标签实现
  let link = document.createElement("a");
  link.href = uri;
  //对下载的文件命名
  link.download = "责编工作量统计.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function exportByUser(jsonData) {
  //列标题，逗号隔开，每一个逗号就是隔开一个单元格
  let str = `责任编辑,稿件数量,已审回,未审回,未送审,已录用,已发表,已退改,已退稿\n`;
  //增加\t为了不让表格显示科学计数法或者其他格式
  for (let i = 0; i < jsonData.length; i++) {
    for (let item in jsonData[i]) {
      str += `${jsonData[i][item] + "\t"},`;
    }
    str += "\n";
  }
  //encodeURIComponent解决中文乱码
  let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
  //通过创建a标签实现
  let link = document.createElement("a");
  link.href = uri;
  //对下载的文件命名
  link.download = "责编工作量统计.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style>
@import "../../../assets/css/PageCss.css";
</style>

